import { render, staticRenderFns } from "./UserActivate.vue?vue&type=template&id=0f17f098"
import script from "./UserActivate.vue?vue&type=script&lang=js"
export * from "./UserActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports